"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TravelWithPeaceOfMind() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="296" id="travel-with-peace-of-mind" className="dark bg-background text-foreground relative overflow-hidden py-[120px] md:py-[180px] px-6">
      {}
      <div className="absolute inset-0 pointer-events-none">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715383/img/travel_insurance_protection.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715383/img/travel_insurance_protection.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715383/img/travel_insurance_protection.png-wvc-sizes" alt="" loading="lazy" decoding="async" aria-hidden="true" className="w-full h-full object-cover opacity-25" />
        <div className="absolute inset-0" style={{
        background: "radial-gradient(ellipse at center, transparent 0%, var(--background) 90%)"
      }} aria-hidden="true" />
      </div>

      {}
      <div ref={ref} className={`relative z-10 mx-auto max-w-[720px] text-center transition-all duration-[1400ms] ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        {}
        <div className="font-default text-2xl mb-10 md:mb-14" style={{
        color: "var(--primary)"
      }} aria-hidden="true">
          
        </div>

        {}
        <h2 className="font-default font-light text-foreground" style={{
        fontSize: "clamp(2.75rem, 7vw, 5rem)",
        lineHeight: 1.05,
        letterSpacing: "-0.01em"
      }}>
          Travel with
          <br />
          complete{" "}
          <span className="relative inline-block italic">
            confidence
            <span className="absolute left-0 right-0 -bottom-1 h-px" style={{
            backgroundColor: "var(--primary)",
            opacity: 0.7
          }} aria-hidden="true" />
          </span>
          .
        </h2>

        {}
        <p className="font-default italic mt-10 md:mt-12 text-foreground/85" style={{
        fontSize: "clamp(1.125rem, 1.6vw, 1.375rem)",
        lineHeight: 1.6
      }}>
          Secure your journey with comprehensive coverage — explore our protection plans today.
        </p>

        {}
        <div className="mt-12 md:mt-14">
          <Button asChild variant="outline" className="group bg-transparent border border-foreground/80 text-foreground hover:bg-foreground hover:text-background h-auto px-10 py-5 md:px-14 md:py-6 text-base font-default tracking-wide rounded-lg transition-colors duration-500">
            <Link to="/ShopPage" aria-label="View Insurance Options">
              <span>View Insurance Options</span>
              <ArrowRight className="ml-2 size-4 transition-transform duration-500 group-hover:translate-x-1" strokeWidth={1.5} />
            </Link>
          </Button>
        </div>

        {}
        <p className="mt-8 md:mt-10 text-xs uppercase font-default" style={{
        color: "var(--primary)",
        letterSpacing: "0.25em"
      }}>
          Instant coverage confirmation
        </p>
      </div>
    </section>;
}